import { USERS_LIST, PROJECT_LIST, PROFILE, DRIVE, SITE_LIST, CHECK_IN, CHECK_OUT, BACK_DATED, TASK_LIST, ATTENDANCE, DASHBOARD, TASK_MASTER_LIST, VIEW_BILLS, BILLS_LIST, ANNOUNCEMENT, APPROVALS, WAREHOUSE_MASTER, STOCK, VIEW_MATERIAL_REQUESTS, RETURN_NOTE, DISPATCH_NOTE, PRODUCT_MASTER, GRN_LIST, PROCUREMENT_MRR, PROCUREMENT_GRN, VIEW_ADVANCE_NOTE, VENDOR_LIST, ADVANCE_NOTES_LIST, CLIENT_MASTER, VENDOR_MASTER , USER_LEDGER_LIST, PROJECT_LEDGER_LIST, SAN_LIST, PRODUCT_META_MASTER, STOCK_TRANSACTION_LEDGER, } from "../routes";
import { ROLES } from "./Strings";

export const menuItemsData = [
  {
    name: "Dashboard",
    route: DASHBOARD,
    roles: [
      ROLES.HEAD_OFFICE,
      ROLES.MANAGING_DIRECTOR,
      ROLES.GOVERNMENT_OFFICER,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
      ROLES.PROJECT_MANAGER,
      ROLES.PROJECT_ENGINEER,
      ROLES.SITE_ENGINEER,
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
    ],
  },
  {
    name: "Approvals",
    route: APPROVALS,
    roles: [
      ROLES.HEAD_OFFICE,
      ROLES.MANAGING_DIRECTOR,
      ROLES.GOVERNMENT_OFFICER,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
      ROLES.PROJECT_MANAGER,
      ROLES.PROJECT_ENGINEER,
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
    ],
  },
  {
    name: "Master",
    roles: [
      ROLES.HEAD_OFFICE,
      ROLES.MANAGING_DIRECTOR,
      ROLES.GOVERNMENT_OFFICER,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
      ROLES.PROJECT_MANAGER,
      ROLES.PROJECT_ENGINEER,
      ROLES.SITE_ENGINEER,
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
    ],
    subItems: [
      {
        name: "Task Master",
        route: TASK_MASTER_LIST,
      },
    ],
  },
  {
    name: "Projects",
    roles: [
      ROLES.HEAD_OFFICE,
      ROLES.MANAGING_DIRECTOR,
      ROLES.GOVERNMENT_OFFICER,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
      ROLES.PROJECT_MANAGER,
      ROLES.PROJECT_ENGINEER,
      ROLES.SITE_ENGINEER,
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
    ],
    subItems: [
      {
        name: "Projects",
        route: PROJECT_LIST,
      },
      {
        name: "Sites",
        route: SITE_LIST,
      },
      {
        name: "All Tasks",
        route: TASK_LIST,
      },
    ],
  },
  {
    name: "Attendance",
    roles: [
      ROLES.HEAD_OFFICE,
      ROLES.MANAGING_DIRECTOR,
      ROLES.GOVERNMENT_OFFICER,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
      ROLES.PROJECT_MANAGER,
      ROLES.PROJECT_ENGINEER,
      ROLES.SITE_ENGINEER,
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
    ],
    subItems: [
      {
        name: "Check In",
        route: CHECK_IN,
      },
      {
        name: "Check Out",
        route: CHECK_OUT,
      },
      {
        name: "Backdated",
        route: BACK_DATED,
      },
      {
        name: "Attendance List",
        route: ATTENDANCE,
      },
    ],
  },
  {
    name: "Accounts",
    roles: [
      ROLES.HEAD_OFFICE,
      ROLES.MANAGING_DIRECTOR,
      ROLES.GOVERNMENT_OFFICER,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
      ROLES.PROJECT_MANAGER,
      ROLES.PROJECT_ENGINEER,
      ROLES.SITE_ENGINEER,
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
    ],
    subItems: [
      {
        name: "Reimbursement Bills",
        route: BILLS_LIST,
      },
      {
        name: "Advance Note",
        route: ADVANCE_NOTES_LIST,
      },
      {
        name: "User Ledger",
        route: USER_LEDGER_LIST,
      },
      {
        name: "Project Ledger",
        route: PROJECT_LEDGER_LIST,
      },
    ],
  },
  {
    name: "Files",
    roles: [
      ROLES.HEAD_OFFICE,
      ROLES.MANAGING_DIRECTOR,
      ROLES.GOVERNMENT_OFFICER,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
      ROLES.PROJECT_MANAGER,
      ROLES.PROJECT_ENGINEER,
      ROLES.SITE_ENGINEER,
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
    ],
    subItems: [
      {
        name: "My Drive",
        route: DRIVE.replace(":type", "my"),
      },
      {
        name: "Shared Drive",
        route: DRIVE.replace(":type", "shared"),
      },
    ],
  },
  {
    name: "Manage",
    roles: [
      ROLES.HEAD_OFFICE,
      ROLES.MANAGING_DIRECTOR,
      ROLES.GOVERNMENT_OFFICER,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
      ROLES.PROJECT_MANAGER,
      ROLES.PROJECT_ENGINEER,
      ROLES.SITE_ENGINEER,
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
    ],
    subItems: [
      {
        name: "Users",
        route: USERS_LIST,
      },
      {
        name: "Profile",
        route: PROFILE,
      },
      {
        name: "Announcements",
        route: ANNOUNCEMENT,
      },
      {
        name: "Client Master",
        route: CLIENT_MASTER,
      },
    ],
  },
  {
    name: "Inventory",
    roles: [
      ROLES.HEAD_OFFICE,
      ROLES.MANAGING_DIRECTOR,
      ROLES.GOVERNMENT_OFFICER,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
      ROLES.PROJECT_MANAGER,
      ROLES.PROJECT_ENGINEER,
      ROLES.SITE_ENGINEER,
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
    ],
    subItems: [
      {
        name: "Product Master",
        route: PRODUCT_MASTER,
      },
      {
        name: "Product Meta Master",
        route: PRODUCT_META_MASTER,
      },
      {
        name: "Warehouse Master",
        route: WAREHOUSE_MASTER,
      },
      {
        name: "Stock",
        route: STOCK,
      },
      {
        name: "Stock Transaction Ledger",
        route: STOCK_TRANSACTION_LEDGER,
      },
      {
        name: "Dispatch Note",
        route: DISPATCH_NOTE,
      },
      {
        name: "Material Requisition Request",
        route: VIEW_MATERIAL_REQUESTS,
      },
      {
        name: "Return Note",
        route: RETURN_NOTE,
      },
      {
        name: "Goods Receive Note",
        route: GRN_LIST,
      },
      {
        name: "Vendor Goods Note",
        route: VENDOR_LIST,
      },
      {
        name: "Stock Adjustment Note",
        route: SAN_LIST,
      }
    ],
  },
  {
    name: "Procurement",
    roles: [
      ROLES.PROCUREMENT_INCHARGE,
      ROLES.BILLING_INCHARGE,
      ROLES.INVENTORY_INCHARGE,
      ROLES.INVENTORY_ADMIN,
    ],
    subItems: [
      {
        name: "Vendor Master",
        route: VENDOR_MASTER,
      },
      {
        name: "Procurement MRR",
        route: PROCUREMENT_MRR,
      },
      {
        name: "Procurement GRN",
        route: PROCUREMENT_GRN,
      },
    ],
  },
];
